import React, { useState } from "react"
import useApi from "../../hooks/useApi.js"

export default function FailedStep({ t, onRetry }) {
  const api = useApi()
  const [ submitting, setSubmitting ] = useState(false)
  const [ error, setError ] = useState(null)

  const retry = async () => {
    setSubmitting(true)
    setError(null)
    try {
      await api.post("/api/v1/shop/crawl")
      onRetry()
    } catch (err) {
      setError(err.message)
      setSubmitting(false)
    }
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <span aria-hidden className="inline-block w-2 h-2 rounded-full bg-failure" />
        <h1 className="text-[28px] font-medium tracking-[-0.035em] text-ink-primary">
          {t("dashboard.onboarding.failed.title")}
        </h1>
      </div>
      <p className="text-sm text-ink-secondary leading-relaxed">
        {t("dashboard.onboarding.failed.lede", { message: error || "" })}
      </p>
      <button
        type="button"
        onClick={retry}
        disabled={submitting}
        className="bg-brand text-ink-on-dark rounded-button px-4 py-2 text-[13px] font-medium disabled:opacity-60"
      >
        {t("dashboard.onboarding.failed.retry")}
      </button>
    </div>
  )
}
